<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-lg-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <argon-input type="text" v-model="form.ref" @update:modelValue="onRefManualEdit" />
              </div>

              <div class="col-md-4">
                <label for="supply-barcode" class="form-control-label">Código de barras</label>
                <argon-input
                  id="supply-barcode"
                  type="text"
                  v-model="form.barcode"
                  placeholder="Escanee o ingrese el código de barras"
                />
              </div>

              <div class="col-md-8">
                <label for="supply-invoice-name" class="form-control-label">Nombre de factura</label>
                <argon-input
                  id="supply-invoice-name"
                  type="text"
                  v-model="form.invoice_name"
                  placeholder="Opcional. Si se define, se usa en el ticket POS en lugar del nombre."
                />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label for="supply-categories" class="form-control-label">Categorías</label>
                <select
                  ref="categorySelect"
                  id="supply-categories"
                  class="form-select select2"
                  multiple
                  style="width: 100%;"
                  v-model="form.category_ids"
                >
                  <option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                  >
                    {{ category.fullname || category.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="supply-marcas" class="form-control-label">Marcas</label>
                <select
                  ref="marcaSelect"
                  id="supply-marcas"
                  class="form-select select2"
                  multiple
                  style="width: 100%;"
                  v-model="form.marca_ids"
                >
                  <option
                    v-for="marca in marcasList"
                    :key="marca.id"
                    :value="marca.id"
                  >
                    {{ marca.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <argon-input type="text" v-model="form.quantity" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>

              <div class="col-md-12 mt-3">
                <div class="card card-precios-venta border shadow-none mb-0">
                  <div class="card-body pt-3 pb-3">
                    <p class="text-uppercase text-sm mb-3">Precios de venta</p>
                    <p class="text-sm mb-3 semaforo-info">
                      Configure hasta 5 precios de venta para comercializar el mismo producto de inventario.
                    </p>
                    <div class="row">
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-precio1" class="form-control-label">Precio 1</label>
                        <argon-input id="supply-precio1" type="number" v-model="form.precio1" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-precio2" class="form-control-label">Precio 2</label>
                        <argon-input id="supply-precio2" type="number" v-model="form.precio2" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-precio3" class="form-control-label">Precio 3</label>
                        <argon-input id="supply-precio3" type="number" v-model="form.precio3" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-precio4" class="form-control-label">Precio 4</label>
                        <argon-input id="supply-precio4" type="number" v-model="form.precio4" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-precio5" class="form-control-label">Precio 5</label>
                        <argon-input id="supply-precio5" type="number" v-model="form.precio5" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-iva" class="form-control-label">IVA (%)</label>
                        <argon-input id="supply-iva" type="number" v-model="form.iva" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-descuento" class="form-control-label">Descuento (%)</label>
                        <argon-input id="supply-descuento" type="number" v-model="form.descuento" />
                      </div>
                      <div class="col-md-4 col-6 mb-3">
                        <label for="supply-descuento-min-unidades" class="form-control-label">Descuento desde (unidades)</label>
                        <argon-input
                          id="supply-descuento-min-unidades"
                          type="number"
                          min="1"
                          v-model="form.descuento_min_unidades"
                          placeholder="1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 d-flex align-items-center mt-4 mb-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="manageStock"
                    v-model="form.manage_stock"
                  />
                  <label class="form-check-label ms-2" for="manageStock">
                    Manejar stock del producto
                  </label>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <div class="card card-semaforo border shadow-none mb-0">
                  <div class="card-body pt-3 pb-3">
                    <p class="text-sm mb-3 semaforo-info">
                      Estos campos se usan como <strong>semáforo</strong> de stock: en rojo cuando el inventario está bajo,
                      en amarillo en nivel medio y en verde cuando el stock es alto.
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <label for="supply-low" class="form-control-label d-flex align-items-center mb-2">
                          <span class="semaforo-dot semaforo-dot--rojo me-2" aria-hidden="true"></span>
                          Cant mínima
                        </label>
                        <argon-input id="supply-low" type="text" v-model="form.low" />
                      </div>

                      <div class="col-md-4">
                        <label for="supply-medium" class="form-control-label d-flex align-items-center mb-2">
                          <span class="semaforo-dot semaforo-dot--amarillo me-2" aria-hidden="true"></span>
                          Cant media
                        </label>
                        <argon-input id="supply-medium" type="text" v-model="form.medium" />
                      </div>

                      <div class="col-md-4">
                        <label for="supply-high" class="form-control-label d-flex align-items-center mb-2">
                          <span class="semaforo-dot semaforo-dot--verde me-2" aria-hidden="true"></span>
                          Cant alta
                        </label>
                        <argon-input id="supply-high" type="text" v-model="form.high" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div class="col-lg-4">
        <div class="card mb-2 inventory-image-card">
          <div class="card-header pb-0">
            <p class="mb-0 text-uppercase text-sm">Imagen del producto</p>
          </div>
          <div class="card-body text-center">
            <div class="inventory-image-preview-wrap mb-3">
              <img
                v-if="displayImageUrl"
                :src="displayImageUrl"
                alt="Imagen del producto"
                class="inventory-image-preview"
                @error="onImageLoadError"
              />
              <div v-else class="inventory-image-placeholder">
                <i class="fas fa-image fa-3x text-secondary opacity-6"></i>
                <p class="text-sm text-muted mt-2 mb-0">Sin imagen</p>
              </div>
            </div>

            <input
              ref="imageInput"
              type="file"
              accept="image/jpeg,image/png,image/jpg,image/webp"
              class="d-none"
              @change="onImageSelected"
            />

            <button
              type="button"
              class="btn btn-sm btn-outline-primary w-100 mb-2"
              :disabled="!form.id"
              @click="$refs.imageInput.click()"
            >
              <i class="fas fa-folder-open me-1"></i>
              Seleccionar imagen
            </button>

            <button
              type="button"
              class="btn btn-sm btn-success w-100"
              :disabled="!canUploadImage"
              @click="uploadImage"
            >
              <i class="fas fa-upload me-1"></i>
              {{ isUploadingImage ? 'Subiendo...' : 'Subir imagen' }}
            </button>

            <p v-if="!form.id" class="text-xs text-muted mt-3 mb-0">
              Guarde el producto una vez para habilitar la subida de imagen.
            </p>
            <p v-else-if="imageFile" class="text-xs text-secondary mt-2 mb-0">
              {{ imageFile.name }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="form.id!=0">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Inventario de producción</h6>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Talla/Color</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producción</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant Producida</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant Remitida</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Bodega</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio de venta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in productionInventory" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value?.model?.name }}</h6>
                          <p class="text-xs text-secondary mb-0">{{ value?.model?.description }}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value?.model?.ref }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <p class="text-xs text-secondary mb-0">
                            {{ value?.size?.size }} / {{ value?.size?.color?.name }} ({{ value?.size?.color?.ref }})
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">#{{ value?.production?.id }} - {{ value?.production?.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="px-2 py-1">
                        <div class="justify-content-center text-center">
                          <h6 class="mb-0 text-sm text-center">{{ value.stock }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="px-2 py-1">
                        <div class="justify-content-center text-center">
                          <h6 class="mb-0 text-sm text-center">{{ value.quantity_to_produce }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="px-2 py-1">
                        <div class="justify-content-center text-center">
                          <h6 class="mb-0 text-sm text-center">{{ value.quantity_sent }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="px-2 py-1">
                        <div class="justify-content-center text-center">
                          <h6 class="mb-0 text-sm text-center">{{ value?.production?.bodega?.name ?? "Sin asignar" }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value?.production?.selling_cost || 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) }}
                    </td>
                  </tr>

                  <tr v-if="productionInventory.length === 0">
                    <td colspan="9" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination p-3">
                <a
                  v-for="link in productionLinks"
                  :key="link.label"
                  class="page-item cursor-pointer"
                  @click="fetchProductionInventory(link.url)"
                  :class="{ active: link.label === productionCurrentPage.toString() }"
                >
                  {{ link.label }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { mapGetters } from 'vuex';
import inventoryService from '@/services/inventory.service';
import { buildInventoryImageUrl } from '@/utils/inventoryImage';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Supplies Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      form: {
        id: 0,
        name: '',
        invoice_name: '',
        barcode: '',
        ref: '',
        description: '',
        quantity: 0,
        status: 1,
        bodega_id: 0,
        price: 0,
        precio1: 0,
        precio2: 0,
        precio3: 0,
        precio4: 0,
        precio5: 0,
        iva: 0,
        descuento: 0,
        descuento_min_unidades: 1,
        manage_stock: true,
        low: 100,
        medium: 200,
        high: 300,
        category_ids: [],
        marca_ids: [],
      },
      bodegas: [],
      categories: [],
      marcasList: [],
      users: [],
      imageFile: null,
      imagePreview: null,
      savedImagePath: '',
      imageCacheBust: '',
      isUploadingImage: false,
      refManuallyEdited: false,
      syncingRefFromName: false,
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    displayImageUrl() {
      if (this.imagePreview) return this.imagePreview;
      const url = buildInventoryImageUrl(this.savedImagePath);
      if (!url) return null;
      return this.imageCacheBust ? `${url}?t=${this.imageCacheBust}` : url;
    },
    canUploadImage() {
      return this.form.id > 0 && this.imageFile && !this.isUploadingImage;
    },
    ...mapGetters('productionModels', ['allData', 'links']),
    ...mapGetters('settings', ['miaAgentEnabled']),
    productionInventory() {
      return this.allData;
    },
    productionCurrentPage() {
      return this.$store.state.productionModels.currentPage;
    },
    productionLinks() {
      return this.links;
    },
  },
  methods: {
    onRefManualEdit() {
      if (this.syncingRefFromName || this.form.id) {
        return;
      }
      this.refManuallyEdited = true;
    },
    proposeRefFromName(name) {
      return String(name || '').trim().replace(/\s+/g, '-');
    },
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    normalizeNumericField(value) {
      if (value === "" || value === null || value === undefined) {
        return 0;
      }
      const n = parseFloat(value);
      return Number.isNaN(n) ? 0 : n;
    },
    normalizeFormPrices() {
      const fields = [
        "price",
        "precio1",
        "precio2",
        "precio3",
        "precio4",
        "precio5",
        "iva",
        "descuento",
      ];
      fields.forEach((key) => {
        this.form[key] = this.normalizeNumericField(this.form[key]);
      });
      const invoice = this.form.invoice_name != null ? String(this.form.invoice_name).trim() : "";
      this.form.invoice_name = invoice || null;
      const minUnits = parseInt(this.form.descuento_min_unidades, 10);
      this.form.descuento_min_unidades = Number.isNaN(minUnits) || minUnits < 1 ? 1 : minUnits;
    },
    async fetchProductionInventory(pageUrl = null) {
      if (!this.form.id) {
        return;
      }

      const params = {
        inventory_id: this.form.id,
        page: pageUrl ? new URL(pageUrl).searchParams.get('page') || 1 : 1,
      };
      await this.$store.dispatch('productionModels/fetchData', params);
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async getCategories() {
      const response = await this.$store.dispatch('categories/getCategories');
      this.categories = response.data || [];
      this.categories.sort((a, b) => (a.fullname || a.name).localeCompare(b.fullname || b.name));
    },
    async getMarcas() {
      const response = await this.$store.dispatch('marcas/getMarcas');
      this.marcasList = response.data || [];
      this.marcasList.sort((a, b) => a.name.localeCompare(b.name));
    },
    parseIdList(value) {
      if (!value) {
        return [];
      }
      if (Array.isArray(value)) {
        return value.map((id) => String(id));
      }
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            return parsed.map((id) => String(id));
          }
        } catch (_error) {
          return value.split(',').filter(Boolean).map((id) => String(id).trim());
        }
      }
      return [String(value)];
    },
    async initCategorySelect() {
      await this.$nextTick();

      if (!this.$refs.categorySelect) {
        return;
      }

      const select = $(this.$refs.categorySelect);
      if (select.hasClass('select2-hidden-accessible')) {
        select.off('change');
        select.select2('destroy');
      }

      select.select2({
        placeholder: 'Seleccionar categorías',
        allowClear: true,
        width: '100%',
      });

      select.on('change', () => {
        const values = select.val() || [];
        this.form.category_ids = values
          .map((id) => parseInt(id, 10))
          .filter((id) => !Number.isNaN(id));
      });

      const categoryArray = this.parseIdList(this.form.category_ids);
      if (categoryArray.length) {
        select.val(categoryArray).trigger('change');
      }
    },
    async initMarcaSelect() {
      await this.$nextTick();

      if (!this.$refs.marcaSelect) {
        return;
      }

      const select = $(this.$refs.marcaSelect);
      if (select.hasClass('select2-hidden-accessible')) {
        select.off('change');
        select.select2('destroy');
      }

      select.select2({
        placeholder: 'Seleccionar marcas',
        allowClear: true,
        width: '100%',
      });

      select.on('change', () => {
        const values = select.val() || [];
        this.form.marca_ids = values
          .map((id) => parseInt(id, 10))
          .filter((id) => !Number.isNaN(id));
      });

      const marcaArray = this.parseIdList(this.form.marca_ids);
      if (marcaArray.length) {
        select.val(marcaArray).trigger('change');
      }
    },
    async initFormSelects() {
      await this.initCategorySelect();
      await this.initMarcaSelect();
    },
    async loadInventoryRelations() {
      if (!this.form.id) {
        return;
      }
      try {
        const response = await inventoryService.getData(this.form.id);
        const data = response.data || {};
        this.form.category_ids = Array.isArray(data.category_ids) ? data.category_ids : [];
        this.form.marca_ids = Array.isArray(data.marca_ids) ? data.marca_ids : [];
      } catch (error) {
        console.error('No se pudieron cargar categorías/marcas del producto:', error);
      }
    },
    setImageFromPath(path) {
      this.savedImagePath = path || '';
      if (path) {
        this.imageCacheBust = Date.now();
      }
    },
    async loadInventoryImage() {
      if (!this.form.id) return;
      try {
        const response = await inventoryService.getData(this.form.id);
        const data = response.data || {};
        this.setImageFromPath(data.image_path || '');
      } catch (e) {
        console.error('No se pudo cargar la imagen del producto:', e);
      }
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        this.normalizeFormPrices();

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          const saved = response.data?.data || response.data;
          if (saved?.id) {
            this.form.id = saved.id;
            this.refManuallyEdited = true;
            await this.fetchProductionInventory();
          }
          if (saved?.image_path) {
            this.setImageFromPath(saved.image_path);
          }
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          if (this.miaAgentEnabled && saved?.id) {
            await Swal.fire({
              icon: 'info',
              title: 'Mia-Agent',
              text: 'El producto se sincronizó automáticamente con Mia-Agent.',
              timer: 3000,
              timerProgressBar: true,
            });
          }

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        const errData = error?.data || error?.response?.data;
        const msg = errData?.errors?.ref?.[0] || errData?.message || error?.message || 'Error al guardar el proyecto';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },

    onImageLoadError() {
      console.warn('No se pudo cargar la imagen:', this.savedImagePath);
    },
    onImageSelected(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      if (this.imagePreview) {
        URL.revokeObjectURL(this.imagePreview);
      }

      this.imageFile = file;
      this.imagePreview = URL.createObjectURL(file);
    },
    async uploadImage() {
      if (!this.form.id || !this.imageFile) return;

      this.isUploadingImage = true;
      try {
        const response = await inventoryService.uploadImage(this.form.id, this.imageFile);
        const path =
          response.data?.image_path ||
          response.data?.inventory?.image_path ||
          '';
        const apiUrl = response.data?.image_url;
        if (apiUrl) {
          this.savedImagePath = apiUrl;
          this.imageCacheBust = Date.now();
        } else if (path) {
          this.setImageFromPath(path);
        }
        if (this.imagePreview) {
          URL.revokeObjectURL(this.imagePreview);
        }
        this.imagePreview = null;
        this.imageFile = null;
        if (this.$refs.imageInput) {
          this.$refs.imageInput.value = '';
        }

        await Swal.fire({
          icon: 'success',
          title: 'Imagen guardada',
          text: response.data?.message || 'La imagen se subió correctamente.',
          confirmButtonText: 'Aceptar',
        });
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo subir la imagen.',
        });
      } finally {
        this.isUploadingImage = false;
      }
    },
    async bootstrapForm(route) {
      await Promise.all([
        this.getBodegas(),
        this.getCategories(),
        this.getMarcas(),
      ]);

      const dataEdit = route.params?.data;

      if (!dataEdit && this.bodegas.length > 0) {
        this.form.bodega_id = this.bodegas[0].id;
      }

      if (dataEdit) {
        try {
          const params = JSON.parse(dataEdit);

          if (params && params.id) {
            this.refManuallyEdited = true;
            this.form = {
              ...this.form,
              ...params,
              manage_stock: this.normalizeBoolean(params.manage_stock),
              category_ids: Array.isArray(params.category_ids) ? params.category_ids : [],
              marca_ids: Array.isArray(params.marca_ids) ? params.marca_ids : [],
            };
            this.normalizeFormPrices();
            this.setImageFromPath(params.image_path || '');
            this.loadInventoryImage();
            this.fetchProductionInventory();
            await this.loadInventoryRelations();
          }
        } catch (error) {
          console.error("Error al parsear los datos del registro:", error);
        }
      }

      await this.initFormSelects();
    },
  },
  watch: {
    'form.name'(value) {
      if (this.form.id || this.refManuallyEdited) {
        return;
      }
      this.syncingRefFromName = true;
      this.form.ref = this.proposeRefFromName(value);
      this.$nextTick(() => {
        this.syncingRefFromName = false;
      });
    },
    '$route'(to) {
      if (to.name !== 'Supplies Create') {
        return;
      }
      this.bootstrapForm(to);
    },
  },
  async mounted() {
    const route = useRoute();
    await this.bootstrapForm(route);

    this.$store.dispatch('settings/get').catch(() => {});

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    if (this.$refs.categorySelect && $(this.$refs.categorySelect).hasClass('select2-hidden-accessible')) {
      $(this.$refs.categorySelect).select2('destroy');
    }
    if (this.$refs.marcaSelect && $(this.$refs.marcaSelect).hasClass('select2-hidden-accessible')) {
      $(this.$refs.marcaSelect).select2('destroy');
    }
    if (this.imagePreview) {
      URL.revokeObjectURL(this.imagePreview);
    }
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

.card-semaforo {
  background-color: #f8f9fa;
}

.card-precios-venta {
  background-color: #f8f9fa;
}

.semaforo-info {
  color: #67748e;
}

.semaforo-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  min-width: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.semaforo-dot--rojo {
  background-color: #ea0606;
}

.semaforo-dot--amarillo {
  background-color: #f5a623;
}

.semaforo-dot--verde {
  background-color: #82d616;
}

.inventory-image-card {
  position: sticky;
  top: 1rem;
}

.inventory-image-preview-wrap {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px dashed #dee2e6;
  overflow: hidden;
}

.inventory-image-preview {
  max-width: 100%;
  max-height: 280px;
  object-fit: contain;
}

.inventory-image-placeholder {
  padding: 2rem 1rem;
}
</style>
